// src/pages/player/PlayerDashboard.jsx
import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { FaUserEdit, FaCalendarPlus, FaAward, FaListAlt } from 'react-icons/fa';

const StatCard = ({ count, label, icon }) => (
    <div className="bg-white p-6 rounded-xl shadow-md flex items-center gap-4">
        <div className="bg-blue-100 text-blue-600 p-3 rounded-full">
            {icon}
        </div>
        <div>
            <p className="text-3xl font-bold text-slate-800">{count}</p>
            <p className="text-slate-500">{label}</p>
        </div>
    </div>
);

const ActionCard = ({ to, title, description, icon }) => (
    <Link 
        to={to} 
        className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all group"
    >
        <div className="text-blue-600 mb-3 w-fit p-3 rounded-full bg-blue-50 group-hover:bg-blue-100 transition-colors">
            {icon}
        </div>
        <h3 className="text-xl font-bold text-slate-800 mb-1">{title}</h3>
        <p className="text-slate-500 group-hover:text-slate-700 transition-colors">{description}</p>
        <span className="font-semibold text-blue-600 mt-4 inline-block opacity-0 group-hover:opacity-100 transition-opacity">
            Go &rarr;
        </span>
    </Link>
);


const PlayerDashboard = () => {
    const { user } = useContext(AuthContext);
    const [stats, setStats] = useState({
        registeredEvents: 0,
        certificates: 0
    });

    // In a real app, you would fetch these stats from an API
    useEffect(() => {
        // Placeholder data. Replace with API calls if endpoints exist.
        // For example:
        // API.getMyRegistrations().then(res => setStats(s => ({...s, registeredEvents: res.data.length})))
        // API.getMyCertificates().then(res => setStats(s => ({...s, certificates: res.data.length})))
        setStats({
            registeredEvents: 3, // Placeholder
            certificates: 2     // Placeholder
        });
    }, []);

    return (
        <div>
            <h1 className="text-4xl font-bold text-slate-800 mb-2">
                Welcome back, {user?.name || 'Player'}!
            </h1>
            <p className="text-slate-600 text-lg mb-8">
                Here's a quick overview of your profile and activities.
            </p>

            {/* Stat Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                <StatCard count={stats.registeredEvents} label="Registered Events" icon={<FaListAlt size={24} />} />
                <StatCard count={stats.certificates} label="Certificates Won" icon={<FaAward size={24} />} />
                {/* You can add more stat cards here if data is available */}
            </div>

            {/* Action Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <ActionCard
                    to="/player-profile"
                    title="My Profile"
                    description="View and update your personal information and uploaded documents."
                    icon={<FaUserEdit size={32}/>}
                />
                <ActionCard
                    to="/register-event"
                    title="Register for an Event"
                    description="Browse all open events and register for new competitions."
                    icon={<FaCalendarPlus size={32}/>}
                />
                <ActionCard
                    to="/certificates"
                    title="My Certificates"
                    description="View and download all your official participation and achievement certificates."
                    icon={<FaAward size={32}/>}
                />
            </div>
        </div>
    );
};

export default PlayerDashboard;
